type SiteIconName =
  | 'home'
  | 'content-records'
  | 'personality-records'
  | 'knowledge-base'
  | 'my-record'
  | 'dashboard'
  | 'settings'
  | 'search'
  | 'pen'

const bucketName = 'site-icons'

const iconFiles: Record<SiteIconName, string> = {
  home: 'home.png',
  'content-records': 'content-records.png',
  'personality-records': 'personality-records.png',
  'knowledge-base': 'knowledge-base.png',
  'my-record': 'my-record.png',
  dashboard: 'dashboard.png',
  settings: 'settings.png',
  search: 'search.png',
  pen: 'pen.png',
}

function getIconUrl(name: SiteIconName) {
  const baseUrl = import.meta.env.VITE_SUPABASE_URL
  if (!baseUrl) return ''
  return `${baseUrl}/storage/v1/object/public/${bucketName}/${iconFiles[name]}`
}

export function SiteIcon({
  name,
  alt,
  className = '',
  framed,
}: {
  name: SiteIconName
  alt?: string
  className?: string
  framed?: boolean
}) {
  const useFrame = framed ?? !(name === 'search' || name === 'pen')
  const url = getIconUrl(name)

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center ${
        useFrame
          ? 'overflow-hidden rounded-[10px] border border-[rgba(32,77,143,0.12)] bg-white shadow-[0_10px_20px_rgba(32,77,143,0.08)]'
          : ''
      } ${className}`}
      aria-hidden={alt ? undefined : true}
    >
      <img
        src={url}
        alt={alt ?? ''}
        className={`h-full w-full ${useFrame ? 'object-cover' : 'object-contain'}`}
        loading="lazy"
        decoding="async"
      />
    </span>
  )
}
